import { createI18n } from 'vue-i18n';
import en from './en.json';
import ru from './ru.json';

export default createI18n({
    legacy: false,
    globalInjection: true,
    locale: localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || "ru",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages: { en, ru },
    missingWarn: false, // Disable warnings for missing keys
    fallbackWarn: false // Disable warnings when falling back to another locale
});
